import { Skeleton, TableCell, TableRow } from "@mui/material";
import React from "react";

const AppTableLoader = ({ cols = 4, items = [], isLoading }) => {
  const _cols = [];
  for (let i = 0; i < cols; i++) {
    _cols.push(i);
  }

  if (isLoading && !items?.length) {
    return (
      <>
        {[1, 2, 3, 4, 5].map((item) => (
          <TableRow key={item}>
            {_cols.map((col) => (
              <TableCell key={col}>
                <Skeleton variant="text" />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </>
    );
  }

  return null;
};

export default AppTableLoader;
